import moment from 'moment';

if (!window.Intl || Intl.NumberFormat.supportedLocalesOf('en-US').length == 0) {
    require('intl');
    require('intl/locale-data/jsonp/en.js');
    Intl.NumberFormat = IntlPolyfill.NumberFormat;
    Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
}

const currencyFormatter = new Intl.NumberFormat(navigator.language || 'en-US', {
    style: 'currency',
    currency: 'USD',
});
const currencyFormatter3 = new Intl.NumberFormat(navigator.language || 'en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 3,
});

export default {
    methods: {
        shortDate(value) {
            if (!value) {
                return '';
            }
            return moment(value).format('M/D/YY');
        },

        usd(amt) {
            const ret = amt !== undefined ? currencyFormatter.format(parseFloat(amt)) : undefined;
            return (ret == "$NaN") ? " - " : ret;
        },

        usd3(amt) {
            return amt !== undefined ? currencyFormatter3.format(parseFloat(amt)) : undefined;
        },
    },

    filters: {
        shortDate(value) {
            return this.shortDate(value);
        },

        usd(amt) {
            return this.usd(amt);
        },

        usd3(amt) {
            return this.usd3(amt);
        },
    },
}
